// assets/pubsub.js
// Dawn expects PUB_SUB_EVENTS to be a global binding (identifier), not only window.PUB_SUB_EVENTS.

var PUB_SUB_EVENTS = (window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  optionValueSelectionChange: 'option-value-selection-change',
  cartError: 'cart-error',
});

// keep subscribers globally (debug-friendly)
var __pubsubSubscribers = (window.__pubsubSubscribers = window.__pubsubSubscribers || new Map());

// Expose as global functions (Dawn uses subscribe()/publish() directly)
function subscribe(eventName, callback) {
  if (!__pubsubSubscribers.has(eventName)) __pubsubSubscribers.set(eventName, []);
  __pubsubSubscribers.get(eventName).push(callback);

  return () => {
    var arr = __pubsubSubscribers.get(eventName) || [];
    __pubsubSubscribers.set(
      eventName,
      arr.filter(function (cb) {
        return cb !== callback;
      })
    );
  };
}

function publish(eventName, payload) {
  var arr = __pubsubSubscribers.get(eventName) || [];
  arr.forEach(function (cb) {
    try {
      cb(payload);
    } catch (e) {
      console.error(e);
    }
  });
}

// also mirror to window (optional)
window.subscribe = window.subscribe || subscribe;
window.publish = window.publish || publish;
